import { render } from "./CardCall.vue?vue&type=template&id=244ac3ce"
import script from "./CardCall.vue?vue&type=script&lang=js"
export * from "./CardCall.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__